import { create } from "zustand";
import { gameService } from "@/services/game.service";
import { Game, GetGamesFilter } from "@/types/game";

interface GamesState {
  games: Game[];
  loading: boolean;
  error: string | null;

  // Actions
  fetchGames: () => Promise<void>;
  fetchPublicGames: (filters?: GetGamesFilter) => Promise<void>;
  fetchGameById: (id: string) => Promise<Game | null>;
  clearError: () => void;
}

export const useGamesStore = create<GamesState>((set) => ({
  games: [],
  loading: false,
  error: null,

  fetchGames: async () => {
    set({ loading: true, error: null });
    try {
      const games = await gameService.findAll();
      set({ games, loading: false });
    } catch (error: any) {
      set({
        error: error.response?.data?.message || "Erro ao carregar jogos",
        loading: false,
      });
    }
  },

  fetchPublicGames: async (filters?: GetGamesFilter) => {
    set({ loading: true, error: null });
    try {
      const games = await gameService.findPublic(filters);
      set({ games, loading: false });
    } catch (error: any) {
      set({
        error:
          error.response?.data?.message || "Erro ao carregar jogos públicos",
        loading: false,
      });
    }
  },

  fetchGameById: async (id: string) => {
    set({ loading: true, error: null });
    try {
      const game = await gameService.findOne(id);
      set({ loading: false });
      return game;
    } catch (error: any) {
      set({
        error: error.response?.data?.message || "Erro ao carregar jogo",
        loading: false,
      });
      return null;
    }
  },

  clearError: () => set({ error: null }),
}));
